import { computed, ExtractPropTypes, ref, watch, SetupContext } from 'vue'
import { humanizeRole } from '@/libs/entities/users/roles'
import { useWhoAmI } from '@/store/profile/whoAmI'
import { DevToolOptions } from '@/tokens/llm/LlmDevTools/types'
import { ASK_SOP_INPUT_PROPS, AskSopInputForm } from './types'

type AskSopInputsPropType = ExtractPropTypes<typeof ASK_SOP_INPUT_PROPS>
/**
 *
 * @param props
 * @param context
 */
export default function (props: AskSopInputsPropType, context: SetupContext) {
  const { roles } = useWhoAmI()
  const inputText = ref('')
  const devToolOptions = ref<DevToolOptions>({})
  const starterUserContext = computed(() => {
    const humanizedRoles = roles.value.map((role) => humanizeRole(role))
    if (humanizedRoles.length === 0) {
      return ''
    }
    return `I have the following roles: ${humanizedRoles.join(', ')}.`
  })
  const userContext = ref(starterUserContext.value)

  /**
   *
   * @param e
   */
  function submitOnEnter(e: KeyboardEvent) {
    if (!e.shiftKey && !e.metaKey && !e.ctrlKey) {
      e.preventDefault()
      submitQuery()
    }
  }

  /**
   *
   */
  function submitQuery() {
    context.emit('submit', {
      query: inputText.value,
      userContext: userContext.value,
      devToolOptions: devToolOptions.value,
    } as AskSopInputForm)
  }

  watch(roles, () => {
    // Reset context text when roles change
    userContext.value = starterUserContext.value
  })

  return {
    inputText,
    devToolOptions,
    userContext,
    submitQuery,
    submitOnEnter,
  }
}
